import { useContext } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import { AppContext } from '../../lib/context/AppContext';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

const AuthRoutes: React.FC = () => {
  const { user } = useContext(AppContext);
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        {!!user && <Redirect to='/account' />}
        {/* {!!user && <Redirect to='/' />} */}
        {!user && (
          <Route exact path={`${path}`}>
            <Redirect to={`${path}/sign-in`} />
          </Route>
        )}

        <Route path={`${path}/sign-in`}>
          <SignIn />
        </Route>
        <Route path={`${path}/sign-up`}>
          <SignUp />
        </Route>
        <Route path={`${path}/forgot-password`}>
          <ForgotPassword />
        </Route>
        <Route path={`${path}/reset-password`}>
          <ResetPassword />
        </Route>
      </Switch>
    </div>
  );
};
export default AuthRoutes;
